<section class="card p-4">
  @if (ticketsByCategory$ | async; as categories) {
    <app-batch-sales-report-table
      [data]="(categories | groupGuests) || []"
      [sellerSummaryPage]="(sellersSummary$ | async) ?? null"
      (sellerPageChange)="handleSellerPageChange($event)">
    </app-batch-sales-report-table>
  } @else {
    <p-skeleton height="2rem" />
    <p-skeleton height="10rem" class="mb-4" />
    <p-skeleton height="2rem" />
    <p-skeleton height="10rem" />
  }
</section>
